/**
 * One screen language at a time (owner, 2026-11-02: "Make it either hindi or english
 * (captains can select their preferred language from their settings or we can set
 * here)"). The person's own choice (users.language) wins, then the outlet's
 * staff_language, then English.
 *
 * POSProvider sets the language on every render (syncLang), before any screen
 * renders, so `t()` can be called anywhere without a hook of its own.
 */

let current = "en";

export function languageFor(user, settings) {
  const own = user?.language;
  if (own === "hi" || own === "en") return own;
  return settings?.staff_language === "hi" ? "hi" : "en";
}

export function syncLang(user, settings) {
  current = languageFor(user, settings);
  return current;
}

export const currentLang = () => current;

const DEVANAGARI = /[ऀ-ॿ]/;

/**
 * A label written "हिंदी · English" (or "हिंदी (English)"), in one language.
 * Text with only one language in it comes back as it is.
 */
export function tr(text, lang = current) {
  if (typeof text !== "string") return text;
  if (text.includes(" · ")) {
    const parts = text.split(" · ");
    const hi = parts.filter(p => DEVANAGARI.test(p));
    const en = parts.filter(p => !DEVANAGARI.test(p));
    if (hi.length && en.length) return (lang === "hi" ? hi : en).join(" · ");
  }
  const paren = text.match(/^(.*[ऀ-ॿ].*?)\s*\(([^()ऀ-ॿ]+)\)\s*$/);
  if (paren) return lang === "hi" ? paren[1].trim() : paren[2].trim();
  return text;
}

export const t = text => tr(text);
